import React from 'react';
import { Spinner, Container } from 'react-bootstrap';
import './LoadingSpinner.css';

/**
 * Full-page loading spinner component
 */
function LoadingSpinner({ message = 'Loading...' }) {
    return (
        <Container
            className="d-flex flex-column justify-content-center align-items-center loading-spinner-container"
            aria-live="polite"
            aria-label={message}
        >
            <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">{message}</span>
            </Spinner>
            <p className="mt-3 text-muted" aria-hidden="true">
                {message}
            </p>
        </Container>
    );
}

export default LoadingSpinner;
